module.exports = __webpack_public_path__ + "img/90.c5bf12da.jpg";